import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { useNavigate } from 'react-router-dom'; 
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; 

const indicesPrixProductionData = [
   {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Février 2026",
    principalLink: "/documents/IndicesIPPAB/INDICE_DU_MOIS_DE_FEVRIER_2026.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "Les prix des produits agricoles enregistrent une variation en augmentation de 3,5% pour le mois de février 2026 contre -2,3% pour le mois de janvier 2026.",
    date: "2026-01-15",
    publicationDate: "2026-02-16",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Janvier 2026",
    principalLink: "/documents/IndicesIPPAB/IPPAB_JANVIER_2026.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "Les prix des produits agricoles enregistrent une variation en diminution de 2,3% pour le mois de janvier 2026 contre -1,5% pour le mois de décembre 2025.",
    date: "2026-01-15",
    publicationDate: "2026-02-16",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Décembre 2025",
    principalLink: "/documents/IndicesIPPAB/IPPAB_DECEMBRE_2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "Les prix des produits agricoles enregistrent une variation en diminution de 1,5% pour le mois de décembre 2025 contre 3,3% pour le mois de novembre 2025.",
    date: "2025-12-15",
    publicationDate: "2026-02-02",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Novembre 2025",
    principalLink: "/documents/IndicesIPPAB/IPPAB_NOVEMBRE_2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "Les prix des produits agricoles enregistrent une variation en augmentation de 3,3% pour le mois de novembre 2025 contre -2,1% pour le mois d’octobre 2025.",
    date: "2025-11-15",
    publicationDate: "2025-02-06",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Octobre 2025",
    principalLink: "/documents/IndicesIPPAB/INDICE_MOIS_OCTOBRE_2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "Les prix des produits agricoles enregistrent une variation en diminution de 2,1% pour le mois d’octobre 2025 contre 0,7% pour le mois de septembre 2025.",
    date: "2025-10-15",
    publicationDate: "2025-11-27",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Septembre 2025",
    principalLink: "/documents/IndicesIPPAB/INDICE_MOIS_SEPTEMBRE_2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "Le mois de septembre 2025 se distingue par une légère reprise des prix des produits agricoles, enregistrant une hausse de 0,7 %, contrastant avec la forte baisse observée en août (-4,1 %).",
    date: "2025-09-15",
    publicationDate: "2025-10-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Août 2025",
    principalLink: "/documents/IndicesIPPAB/INDICE_MOIS_AOUT_2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "Le mois d'août 2025 a été marqué par une accentuation significative de la baisse des prix agricoles, avec un recul de 4,1 % qui contraste fortement avec la stabilité relative du mois de juillet (-0,3 %).",
    date: "2025-08-15",
    publicationDate: "2025-10-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Juillet  2025",
    principalLink: "/documents/IndicesIPPAB/ippab_juillet2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En juillet 2025, les prix agricoles reculent de 0,3 % contre une hausse de 4,3 % en juin.",
    date: "2025-07-15",
    publicationDate: "2025-08-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Juin  2025",
    principalLink: "/documents/IndicesIPPAB/ippab_juin2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En juin 2025, les prix agricoles progressent de 4,3 % contre 0,9 % en mai.",
    date: "2025-06-15",
    publicationDate: "2025-07-15",
  },
      {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Mai  2025",
    principalLink: "/documents/IndicesIPPAB/ippab_mai2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En mai 2025, les prix agricoles augmentent de 0,9 % contre 8,5 % en avril.",
    date: "2025-05-15",
    publicationDate: "2025-06-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Mars  2025",
    principalLink: "/documents/IndicesIPPAB/ippab_mars2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En mars 2025, les prix agricoles progressent de 1,8 % contre 5,2 % en février.",
    date: "2025-03-15",
    publicationDate: "2025-04-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Février  2025",
    principalLink: "/documents/IndicesIPPAB/ippab_fevrier2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En février 2025, les prix agricoles augmentent de 5,2 % contre 0,1 % en janvier.",
    date: "2025-02-15",
    publicationDate: "2025-03-15",
  },
     {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Janvier 2025",
    principalLink: "/documents/IndicesIPPAB/ippab_janvier2025.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En janvier 2025, l’IPPAB affiche une légère hausse de 0,1 % contre 1 % en décembre 2024, traduisant une faible variation des prix agricoles.",
    date: "2025-02-15",
    publicationDate: "2025-03-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Décembre 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_DECEMBRE_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En décembre 2024, les prix à la production agricole affichent un ralentissement de la hausse à +1,0 %, marqué par un net reflux des produits de la pêche (-9,8 %) et une contraction des tubercules, partiellement compensé par le rebond des légumineuses (+7,2 %), clôturant l'année sur une stabilisation relative des marchés.",
    date: "2025-01-15",
    publicationDate: "2025-01-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Novembre 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_NOVEMBRE_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En novembre 2024, les prix à la production agricole maintiennent une dynamique haussière à +4,1 %, bien que modérée par rapport au mois précédent, portée par l'explosion des prix de la pêche (+20,6 %) et la résilience des tubercules (+3,6 %), malgré un net repli sur certains marchés céréaliers.",
    date: "2024-12-15",
    publicationDate: "2024-12-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Octobre 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_OCTOBRE_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En octobre 2024, les prix à la production agricole connaissent une forte poussée de +6,0 %, portée principalement par la nette reprise des tubercules (+7,8 %) et la performance soutenue des céréales (+1,5 %), notamment de l'éleusine (+11,7 %), signalant une reprise de la tension inflationniste sur les marchés agricoles.",
    date: "2024-11-15",
    publicationDate: "2024-11-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), septembre 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_SEPTEMBRE_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En septembre 2024, les prix à la production agricole se stabilisent avec une très légère hausse de +0,1 %, tirée par le dynamisme des produits de la pêche (+5,2 %) et des légumineuses (+2,3 %), qui compensent le fléchissement des céréales (-0,6 %) et des tubercules, marquant une pause dans les fluctuations du marché.",
    date: "2024-10-15",
    publicationDate: "2024-10-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Août 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_AOUT_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En août 2024, les prix à la production agricole marquent un repli de -0,5 %, interrompant une période de hausses soutenues, malgré la performance positive des céréales (+2,4 %) et de la pêche (+3,4 %) qui ne suffisent pas à compenser les corrections observées sur les légumineuses et les tubercules. ",
    date: "2024-09-15",
    publicationDate: "2024-09-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Juillet 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_JUILLET_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En juillet 2024, les prix à la production agricole connaissent une nette accélération avec une hausse de +4,4 %, tirée par une flambée historique des prix de la pêche (+18,4 %) et une performance robuste de l'ensemble des céréales (+2,3 %), notamment du sorgho et de l'éleusine qui affichent des progressions à deux chiffres.",
    date: "2024-08-15",
    publicationDate: "2024-08-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), juin 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_JUIN_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En juin 2024, les prix à la production agricole affichent une forte accélération de +3,3 %, portée par la dynamique exceptionnelle des légumineuses (+6,5 %) et un rebond généralisé des céréales (+1,7 %), notamment du blé (+8,7 %), confirmant une tendance haussière soutenue sur l'ensemble des filières.",
    date: "2024-07-15",
    publicationDate: "2024-07-15",
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Mai 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_MAI_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En mai 2024, les prix à la production agricole renouent avec la hausse (+2,2 %), après le repli d'avril, portée par le rebond vigoureux des légumineuses (+4,1 %) ; cette tendance générale masque toutefois une contraction persistante sur le marché des céréales (-2,7 %) et des tubercules (-1,3 %).",
    date: "2024-06-15",
    publicationDate: "2024-06-15",
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Avril 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_AVRIL_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En avril 2024, les prix à la production agricole marquent une pause avec un repli mensuel de -0,4 %, suivant une forte hausse en mars (+2,7 %) ; ce retournement est généralisé, touchant particulièrement la pêche (-2,6 %) et les tubercules (-1,7 %), malgré des performances positives isolées sur le blé et le riz paddy. ",
    date: "2024-05-15",
    publicationDate: "2024-05-15",
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Mars 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_MARS_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En mars 2024, les prix à la production agricole enregistrent une hausse mensuelle accélérée de +2,7 %, portée notamment par la vigueur des tubercules (+2,9 %) et malgré un net retournement de tendance pour les légumineuses (-3,1 %) ; les céréales, bien que globalement stables (+0,5 %), présentent des dynamiques contrastées en leur sein.",
    date: "2024-04-15",
    publicationDate: "2024-04-15"
  },
    {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Février 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_FEVRIER_2024.pdf",
    image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "En février 2024, les prix à la production agricole affichent une hausse mensuelle de +1,6 %, tirée par les légumineuses (+4,3 %), les tubercules et les produits de la pêche (chacun +1,9 %), compensant le recul des céréales (-1,8 %) où seule la variété de sorgho résiste à la tendance baissière.",
    date: "2024-03-15",
    publicationDate: "2024-03-15"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Janvier 2024",
    principalLink: "/documents/IndicesIPPAB/INDICE_JANVIER_2024.pdf",
     image: 'assets/indicesIPPAB/ippab2024_4m.PNG',
    description: "L'Indice des Prix à la Production Agricole de janvier 2024 s'établit à 185,1 en base 100, affichant une hausse globale de 85,1 % depuis l'année de référence, avec des écarts sectoriels prononcés : les produits de la pêche enregistrent l'indice le plus élevé (349,6), tandis que ceux de la sylviculture et de l'exploitation forestière présentent l'indice le plus modéré (121,3).",
    date: "2024-02-14",
    publicationDate: "2024-02-14"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Décembre 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-de-decembre-2023.pdf",
    image: 'assets/indicesIPPAB/ippab2023_12m.PNG',
    description: "Une hausse des prix de 3,9 % en décembre 2023, comparé à une hausse de 2,1 % en novembre de la même année.",
    date: "2023-12-30",
    publicationDate: "2024-01-22"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Novembre 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-de-Novembre-2023.pdf",
    image: 'assets/indicesIPPAB/ippab2023_11m.PNG',
    description: "Une hausse de 2,1 % a été enregistrée en novembre 2023, après une augmentation de 0,4 % en octobre.",
    date: "2023-11-30",
    publicationDate: "2023-12-11"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Octobre 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-dOctobre-2023.pdf",
    image: 'assets/indicesIPPAB/ippab2023_10m.PNG',
    description: "Une augmentation de 0,4 % en octobre 2023, contrastant avec une hausse de 1,1 % en septembre.",
    date: "2023-10-01",
    publicationDate: "2023-11-13"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Septembre 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-de-Septembre-2023.pdf",
    image: 'assets/indicesIPPAB/ippab2023_9m.PNG',
    description: "Une hausse des prix de 1,1 % en septembre 2023, suite à une hausse de 3,2 % en août.",
    date: "2023-09-01",
    publicationDate: "2023-10-12"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Août 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-daout-2023.pdf",
    image: 'assets/indicesIPPAB/ippab2023_8m.PNG',
    description: "Une hausse des prix de 3,2 % en août 2023, après une hausse de 1,6 % en juillet.",
    date: "2023-08-01",
    publicationDate: "2023-09-12"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Juillet 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-de-juillet-2023-_4_.pdf",
    image: 'assets/indicesIPPAB/ippab2023_7m.PNG',
    description: "Une hausse de 1,6 % en juillet 2023, suite à une baisse de 2,6 % en juin.",
    date: "2023-07-30",
    publicationDate: "2023-08-11"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Juin 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-de-juin-2023.pdf",
    image: 'assets/indicesIPPAB/ippab2023_6m.PNG',
    description: "Une baissé de 2,6 % en juin 2023, après une hausse de 2,4 % en mai.",
    date: "2023-06-30",
    publicationDate: "2023-09-14"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Mai 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-de-MAI-2023.pdf",
    image: 'assets/indicesIPPAB/ippab2023_5m.PNG',
    description: "Une hausse de 2,4 % en mai 2023, suite à une augmentation de 0,8 % en avril.",
    date: "2023-05-30",
    publicationDate: "2023-06-14"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Avril 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-davril-2023.docx",
    //image: 'assets/indicesIPPAB/ippab2023_4m.PNG',
    image: 'assets/indicesIPPAB/ippab2023_5m.PNG',
    description: "Une hausse des prix de 0,8 % en avril 2023, contrastant avec une hausse notable de 4,8 % en mars.",
    date: "2023-04-30",
    publicationDate: "2023-05-12"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Mars 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-de-Mars-2023.docx",
   // image: 'assets/indicesIPPAB/ippab2023_3m.PNG',
    image: 'assets/indicesIPPAB/ippab2023_5m.PNG',
    description: "Une forte hausse de 4,8 % en mars 2023, après une légère augmentation de 0,7 % en février.",
    date: "2023-03-30",
    publicationDate: "2023-04-12"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Février 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-de-Février-20223-1.docx",
    //image: 'assets/indicesIPPAB/ippab2023_2m.PNG',
    image: 'assets/indicesIPPAB/ippab2023_5m.PNG',
    description: "Une hausse des prix de 0,7 % en février 2023, après une hausse de 1,4 % enregistré en janvier.",
    date: "2023-02-28",
    publicationDate: "2023-03-13"
  },
  {
    title: "Indices des Prix à la Production Agricole au Burundi (IPPAB), Janvier 2023",
    principalLink: "/documents/IndicesIPPAB/Indice-PPA-du-mois-de-janvier-2023.docx",
    //image: 'assets/indicesIPPAB/ippab2023_1m.PNG',
    image: 'assets/indicesIPPAB/ippab2023_5m.PNG',
    description: "Une hausse des prix de 1,4 % en janvier 2023, après une hausse significative de 5,8 % en décembre 2022.",
    date: "2023-01-30",
    publicationDate: "2023-02-13"
  },
];



function IndicePrixProductionAgricole() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredIndices, setFilteredIndices] = useState(indicesPrixProductionData);
  const navigate = useNavigate(); 

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredIndices(indicesPrixProductionData);
    } else {
      const filtered = indicesPrixProductionData.filter((indice) => {
        const indiceYear = new Date(indice.date).getFullYear();
        return indiceYear === parseInt(year);
      });
      setFilteredIndices(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />

        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
            Indice des Prix à la Production Agricole
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            L'indice des prix à la production agricole est un bulletin mensuel qui présente un indice composite basé sur l'observation des prix de diverses denrées agricoles. La méthodologie utilisée est de type input avec une formule de Laspeyres, couvrant l'ensemble du territoire national, à l'exception de la Mairie de Bujumbura. Les coefficients de pondération sont calculés en utilisant les structures des comptes nationaux de 2014.
          </Typography>

          <FormControl fullWidth variant="outlined"  style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionner par l'année de réalisation</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionner par l'année de réalisation"
            >
              <MenuItem value="Tous">Tous les indices </MenuItem>
              {[...new Set(indicesPrixProductionData.map((indice) => new Date(indice.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

       
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredIndices.slice(0, visibleCount).map((indice, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={indice.principalLink}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 110, m: 2 }}
                        image={indice.image}
                        alt={indice.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                        <a
                          href={indice.principalLink}
                          rel="noopener noreferrer"
                          target="_blank"
                          style={{ textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                          {<DownloadIcon />}{indice.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {indice.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(indice.publicationDate).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredIndices.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus d'Indices
            </Button>
          )}
           <br />
         <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px', lineHeight: 1.6 }}>
  <strong>Note :</strong> Les indices des prix à la production agricole sont publiés le <strong>15 de chaque mois</strong>, soit 15 jours après la fin du mois précédent. Les dates de publication des indices pour les mois à venir sont les suivantes :
  <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
    <li><strong>15 janvier</strong> - Publication des indices du mois de décembre</li>
    <li><strong>15 février</strong> - Publication des indices du mois de janvier</li>
    <li><strong>15 mars</strong> - Publication des indices du mois de février</li>
    <li><strong>15 avril</strong> - Publication des indices du mois de mars</li>
    <li><strong>15 mai</strong> - Publication des indices du mois d'avril</li>
    <li><strong>15 juin</strong> - Publication des indices du mois de mai</li>
    <li><strong>15 juillet</strong> - Publication des indices du mois de juin</li>
    <li><strong>15 août</strong> - Publication des indices du mois de juillet</li>
    <li><strong>15 septembre</strong> - Publication des indices du mois d'août</li>
    <li><strong>15 octobre</strong> - Publication des indices du mois de septembre</li>
    <li><strong>15 novembre</strong> - Publication des indices du mois d'octobre</li>
    <li><strong>15 décembre</strong> - Publication des indices du mois de novembre</li>
  </ul>
</Typography>

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button
              onClick={() => navigate('/indice')}
              style={{
                marginTop: '5px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page des indices
            </Button>
          </Box>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default IndicePrixProductionAgricole;